var _filter, _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _rect2, _rect3, _circle, _circle2, _circle3, _circle4, _rect4, _rect5, _polygon, _rect6, _polygon2, _rect7, _rect8, _path8, _rect9, _path9, _path0, _path1, _line, _line2, _path10, _rect0, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _line3, _line4, _line5, _line6, _path24, _line7, _line8, _line9, _line0, _rect1, _rect10, _polygon3, _path25, _line1, _rect11, _circle5, _line10, _path26, _path27, _rect12, _rect13, _rect14, _circle6, _rect15, _rect16, _circle7, _circle8, _circle9, _circle0, _path28, _rect17, _rect18, _rect19, _rect20, _polygon4, _rect21, _path29, _path30, _rect22, _rect23, _rect24, _circle1, _line11, _path31, _line12, _line13, _line14, _line15, _rect25, _path32, _polygon5, _polygon6, _rect26, _polygon7, _path33, _polygon8, _rect27, _line16, _line17, _line18, _line19, _rect28, _path34, _path35, _polygon9, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _polygon0, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _line20, _rect55, _rect56, _rect57, _path36, _rect58, _rect59, _rect60, _path37, _line21, _line22, _polyline, _polyline2, _rect61, _rect62, _line23, _line24, _line25, _line26, _line27, _rect63, _line28, _line29, _line30, _line31, _line32, _rect64, _line33, _line34, _line35, _line36, _line37, _rect65, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _rect66, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _path38, _path39, _path40, _path41, _path42, _rect67, _rect68, _rect69, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfunctionsKaplanHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 918 612",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "dropshadow",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    result: "offsetblur"
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.2
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1812,
    height: 22.1999,
    fill: "white",
    transform: "translate(0.109375 1)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-normal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#2D4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#2D4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#2D4375"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    id: "group-alert"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5911 13.2864L17.2648 11.6765L15.34 8.11769L13.0805 8.62609L11.4068 7.6093L10.8209 5.40625H6.72031L6.1345 7.6093L4.37709 8.62609L2.20124 7.94823L0.109077 11.507L1.69912 13.2016V15.32L0.0253906 17.0146L2.03387 20.4886L4.20972 19.8108L5.88345 20.8276L6.46925 23.1154H10.4862L11.1557 20.9123L12.9131 19.8955L15.089 20.5734L17.1811 17.0146L15.5074 15.32L15.5911 13.2864Z",
    fill: "#FF0032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 9.8125H8.06055V15.5743H9.31584V9.8125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.31584 16.8447H8.06055V18.1157H9.31584V16.8447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1809 3.88091L17.7667 3.28778L17.0135 2.01679L16.1767 2.18626L15.5909 1.84733L15.4235 1H13.9171L13.6661 1.84733L12.9966 2.18626L12.2434 1.93206L11.4902 3.20305L12.076 3.79618V4.55877L11.4902 5.23663L12.2434 6.50762L13.0803 6.25342L13.6661 6.59235L13.8335 7.43968H15.3398L15.5909 6.59235L16.2604 6.25342L17.0972 6.50762L17.8504 5.23663L17.2646 4.6435L17.1809 3.88091Z",
    fill: "#FF0032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 2.61035H14.3359V4.72867H14.8381V2.61035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8381 5.23633H14.3359V5.74472H14.8381V5.23633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 8.54106L23.2065 7.94794L22.4533 6.67695L21.6164 6.84641L21.0306 6.50748L20.8632 5.66016H19.3569L19.1058 6.50748L18.52 6.84641L17.7668 6.59221L17.0137 7.8632L17.5995 8.45633V9.21892L17.0137 9.81205L17.7668 11.083L18.6037 10.8288L19.1895 11.1678L19.3569 12.0151H20.8632L21.1143 11.1678L21.7838 10.8288L22.6207 11.083L23.3738 9.81205L22.788 9.21892L22.6207 8.54106Z",
    fill: "#FF0032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 7.27051H19.8594V9.38882H20.3615V7.27051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3615 9.89648H19.8594V10.3201H20.3615V9.89648Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 9,
    r: 8,
    filter: "url(#dropshadow)",
    id: "default",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "normal"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2D4275",
    d: "M8,15.75 C7.01042,15.75 6.05339,15.5612 5.12891,15.1836 C4.20443,14.806 3.39062,14.2591 2.6875,13.543 C1.98438,12.8529 1.44401,12.0456 1.06641,11.1211 C0.688802,10.1966 0.5,9.23958 0.5,8.25 C0.5,7.22135 0.695312,6.2513 1.08594,5.33984 C1.48958,4.42839 2.02995,3.63411 2.70703,2.95703 C3.38411,2.27995 4.17839,1.73958 5.08984,1.33594 C6.0013,0.945312 6.97135,0.75 8,0.75 C9.02865,0.75 9.9987,0.945312 10.9102,1.33594 C11.8216,1.72656 12.6159,2.26693 13.293,2.95703 C13.9831,3.63411 14.5234,4.42839 14.9141,5.33984 C15.3047,6.2513 15.5,7.22135 15.5,8.25 C15.5,9.23958 15.3112,10.1966 14.9336,11.1211 C14.556,12.0456 14.0156,12.8529 13.3125,13.543 C12.6094,14.2591 11.7956,14.806 10.8711,15.1836 C9.94661,15.5612 8.98958,15.75 8,15.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.625,7 L8.625,12 L7.375,12 L7.375,7 L8.625,7 Z M8.625,4.5 L8.625,5.75 L7.375,5.75 L7.375,4.5 L8.625,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "normal-highlight"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#15D4F1",
    d: "M8,15.75 C7.01042,15.75 6.05339,15.5612 5.12891,15.1836 C4.20443,14.806 3.39062,14.2591 2.6875,13.543 C1.98438,12.8529 1.44401,12.0456 1.06641,11.1211 C0.688802,10.1966 0.5,9.23958 0.5,8.25 C0.5,7.22135 0.695312,6.2513 1.08594,5.33984 C1.48958,4.42839 2.02995,3.63411 2.70703,2.95703 C3.38411,2.27995 4.17839,1.73958 5.08984,1.33594 C6.0013,0.945312 6.97135,0.75 8,0.75 C9.02865,0.75 9.9987,0.945312 10.9102,1.33594 C11.8216,1.72656 12.6159,2.26693 13.293,2.95703 C13.9831,3.63411 14.5234,4.42839 14.9141,5.33984 C15.3047,6.2513 15.5,7.22135 15.5,8.25 C15.5,9.23958 15.3112,10.1966 14.9336,11.1211 C14.556,12.0456 14.0156,12.8529 13.3125,13.543 C12.6094,14.2591 11.7956,14.806 10.8711,15.1836 C9.94661,15.5612 8.98958,15.75 8,15.75 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.625,7 L8.625,12 L7.375,12 L7.375,7 L8.625,7 Z M8.625,4.5 L8.625,5.75 L7.375,5.75 L7.375,4.5 L8.625,4.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "warning",
    transform: "translate(.317 -.142)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFD200",
    points: "8.883 .75 13.238 8.25 17.555 15.75 .25 15.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.625,12.625 L9.625,13.875 L8.375,13.875 L8.375,12.625 L9.625,12.625 Z M9.625,5.75 L9.625,11.375 L8.375,11.375 L8.375,5.75 L9.625,5.75 Z"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropshadow)",
    id: "alert",
    transform: "translate(.317 -.142)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0032",
    points: "8 .5 15.5 4.836 15.5 13.488 8 17.824 .5 13.488 .5 4.836"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.625,12.375 L8.625,13.625 L7.375,13.625 L7.375,12.375 L8.625,12.375 Z M8.625,5.5 L8.625,11.125 L7.375,11.125 L7.375,5.5 L8.625,5.5 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    id: "add",
    filter: "url(#dropshadow)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M15,7.5 C15,8.5417 14.8047,9.5117 14.4141,10.4102 C14.0234,11.3216 13.4831,12.1224 12.793,12.8125 C12.1159,13.4896 11.3216,14.0234 10.4102,14.4141 C9.5117,14.8047 8.5417,15 7.5,15 C6.4583,15 5.4883,14.8047 4.5898,14.4141 C3.6784,14.0234 2.8776,13.4896 2.1875,12.8125 C1.5104,12.1224 0.9766,11.3216 0.5859,10.4102 C0.1953,9.5117 0,8.5417 0,7.5 C0,6.4583 0.1953,5.4883 0.5859,4.5898 C0.9766,3.67839 1.5104,2.88411 2.1875,2.20703 C2.8776,1.51693 3.6784,0.97656 4.5898,0.58594 C5.4883,0.19531 6.4583,0 7.5,0 C8.5417,0 9.5117,0.19531 10.4102,0.58594 C11.3216,0.97656 12.1159,1.51693 12.793,2.20703 C13.4831,2.88411 14.0234,3.67839 14.4141,4.5898 C14.8047,5.4883 15,6.4583 15,7.5 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "8.004 7.01 10.79 7.01 10.79 8.004 8.004 8.004 8.004 10.888 6.996 10.888 6.996 8.004 4.21 8.004 4.21 7.01 6.996 7.01 6.996 4.112 8.004 4.112"
  })), /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .malfunction {\n        cursor: pointer;\n      }\n\n      .group {\n        cursor: pointer;\n      }\n\n     .cls-1, .cls-10, .cls-14, .cls-3, .cls-5, .cls-9 {\n        fill: none;\n      }\n\n      .cls-1 {\n        stroke: #ededed;\n      }\n\n      .cls-1, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-19, .cls-2, .cls-20, .cls-3, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-2 {\n        fill: #ededed;\n      }\n\n      .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-2, .cls-20, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke: #202020;\n      }\n\n      .cls-3 {\n        stroke: #6f6f6f;\n      }\n\n      .cls-20, .cls-4, .cls-8 {\n        fill: #ddd;\n      }\n\n      .cls-5 {\n        stroke: #9c9c9c;\n      }\n\n      .cls-12, .cls-6 {\n        fill: #9c9c9c;\n      }\n\n      .cls-19, .cls-7 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        stroke-dasharray: 2.08 2.08 2.08 2.08 2.08 2.08;\n      }\n\n      .cls-11 {\n        fill: #f6f6f6;\n      }\n\n      .cls-12, .cls-19, .cls-20 {\n        stroke-linejoin: bevel;\n      }\n\n      .cls-13 {\n        fill: #6f6f6f;\n      }\n\n      .cls-14 {\n        stroke-linecap: round;\n      }\n\n      .cls-15, .cls-16, .cls-17, .cls-18 {\n        fill: #202020;\n      }\n\n      .cls-15 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-16 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-17 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-18 {\n        stroke-width: 1.5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M717.78,407.51H698.17a1.79,1.79,0,0,1-1.79-1.79v-4.48a1.79,1.79,0,0,0-1.79-1.79H675.38a1.8,1.8,0,0,1-1.79-1.78v-4.76a1.8,1.8,0,0,0-1.79-1.78h-4.43a1.79,1.79,0,0,1-1.79-1.79h0a1.8,1.8,0,0,0-1.79-1.78H647.35a1.8,1.8,0,0,0-1.79,1.78V401a1.8,1.8,0,0,1-1.78,1.79H629.19a2.41,2.41,0,0,1-2.41-2.41v-7.25a2.39,2.39,0,0,0-2.39-2.41h0a2.42,2.42,0,0,0-2.42,2.42v7.25h0a2.39,2.39,0,0,1-2.38,2.4h-81a2.43,2.43,0,0,1-2.41-2.4v-4.15a3.21,3.21,0,0,0-3.19-3.19H519a2.43,2.43,0,0,1-2.41-2.42V367.41h0a2.39,2.39,0,0,0-2.4-2.4h-82a2.41,2.41,0,0,0-2.41,2.41h0v20.63a2.39,2.39,0,0,1-2.39,2.41h-4a2.41,2.41,0,0,1-2.41-2.41h0V196a2.8,2.8,0,0,1,2.8-2.8h6.47"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 528.56,
    y: 414.66,
    width: 189.3,
    height: 23.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M726.06,300.26V521.67a2.8,2.8,0,0,1-2.8,2.8H655.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M717.78,451.83c-25.64,2.69-46.54,15-59.08,24.37a154.53,154.53,0,0,1-35.5,19.93L534.52,531.2A112.87,112.87,0,0,1,493,539.11H423.77c-64.17,0-116.2-50.44-116.2-112.65,0-50.67,34.51-93.52,82-107.69V275.21h-66.5L143.72,143.93a75,75,0,0,0-44.3-14.48H33V81.06H0V576.47H33V437h91L300.32,563.4a75,75,0,0,0,43.68,14H477.2A199.91,199.91,0,0,0,556.43,561l156.22-67.4a20,20,0,0,1,7.93-1.63h28.1l-.1-131.47H710.23a20,20,0,0,1-9.05-2.16L582.37,298.1v42.55l30,11.84a250.65,250.65,0,0,1,50.4,27.13c12.75,8.83,32,19.05,55,21.47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M398.56,415.46V182.28a2.8,2.8,0,0,1,2.8-2.8h29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M346,94.1c0,5.62,29.23,45.75,61.76,45.75h0a1.49,1.49,0,0,1,1.49,1.48v195a2.8,2.8,0,0,0,2.8,2.8h32.21"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M259.42,41.37c37.72,62.66,80.75,53.07,87.27,53.76"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M251.12,67.28c22.62,37.28,58.78,38.44,70.1,36"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 295.76,
    y: 190.55,
    width: 73.8,
    height: 3.83
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 293.01,
    y: 194.38,
    width: 79.29,
    height: 16.3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 353.83,
    cy: 185.88,
    r: 4.67
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 341.76,
    cy: 185.88,
    r: 4.67
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 323.73,
    cy: 185.88,
    r: 4.67
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 311.66,
    cy: 185.88,
    r: 4.67
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 311.5,
    y: 122.76,
    width: 42.15,
    height: 58.45
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 353.83,
    y: 172.51,
    width: 10.78,
    height: 4.07
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "353.64 169.21 364.61 169.21 364.61 140.36 353.64 123.35 353.64 169.21"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 300.7,
    y: 172.5,
    width: 10.78,
    height: 4.07
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "311.49 169.21 300.69 169.21 300.69 140.36 311.49 123.35 311.49 169.21"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 311.5,
    y: 118.49,
    width: 42.15,
    height: 4.28
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 345.08,
    y: 94.25,
    width: 1.8,
    height: 24.24
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346,111.56h0a3,3,0,0,1-3-3V99.3a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v9.24A3,3,0,0,1,346,111.56Z"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 318.44,
    y: 102.81,
    width: 1.8,
    height: 15.38
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M319.33,114.48h0a3,3,0,0,1-3-3V107.8a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3v3.66A3,3,0,0,1,319.33,114.48Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M0,576.47H33V437h91L300.32,563.4a75,75,0,0,0,43.68,14H477.2A199.91,199.91,0,0,0,556.43,561l156.22-67.4a20,20,0,0,1,7.93-1.63h28.1l-.1-131.47H710.23a20,20,0,0,1-9.05-2.16L582.37,298.1v42.55l30,11.84a250.65,250.65,0,0,1,50.4,27.13c12.75,8.83,32,19.05,55,21.47"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M717.78,451.83c-25.64,2.69-46.54,15-59.08,24.37a154.53,154.53,0,0,1-35.5,19.93L534.52,531.2A112.87,112.87,0,0,1,493,539.11H423.77c-64.17,0-116.2-50.44-116.2-112.65,0-50.67,34.51-93.52,82-107.69V275.21h-66.5L143.72,143.93a75,75,0,0,0-44.3-14.48H33V81.06H0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 32.95,
    y1: 31.88,
    x2: 32.95,
    y2: 85.45
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 32.95,
    y1: 129.45,
    x2: 32.95,
    y2: 437.63
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M748.58,360.6l99.67-15.49V507.53l-99.67-15.42Z"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 717.87,
    y: 401.06,
    width: 7.83,
    height: 50.78
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M738.61,453.65c.58-1.15,2.13-7.41,3.2-12a9.16,9.16,0,0,1,1.89-2.8,5.2,5.2,0,0,0,1.11-2.36L750.93,406a4.63,4.63,0,0,0-.14-2.92,10,10,0,0,1-.29-3.73l.7-3.49c.77-3.52,1.94-11.47,1.94-11.47-2.49,4.38-8.72,34-8.72,34-.52,4.9-6.79,33.9-7.67,36.5,0,0-.69,1.75-1.32,1.7,1.81.48,3.18-3.05,3.18-3.05"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M758.13,401.08s-12.74-1.63-17.33-1.63a96.16,96.16,0,0,0-12.1,1.25c-.93.21-2.08.38-2.08.38h-.93v50.59h.93s1.15.17,2.08.38a96.16,96.16,0,0,0,12.1,1.25c4.59,0,17.33-1.63,17.33-1.63Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M753.35,397.22c0,3.37-4.58,6.1-10.23,6.1s-10.22-2.73-10.22-6.1Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M743.12,399s-4.54-.13-7.51,5.41c0,0-1.41,3.48-4.51,3.48s-3.12-6.57-3-10.83c.18-5.1,2.27-30.95,9.38-35.54,2-1.28,4.69-.85,6.26-.85a7.89,7.89,0,0,1,5,1.83c2.08,1.75,3.61,5.6,5.39,12.64A225.25,225.25,0,0,1,759,399l-9.8,1.8A15.43,15.43,0,0,0,743.12,399Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M754.6,455.46c0-3.37-4.58-6.1-10.22-6.1s-10.23,2.73-10.23,6.1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M744.38,453.78c8.59-.34,16.49-7.95,16.49-7.95l-5.65,23.38c-3,12.8-5.44,18.48-7.63,21-1.41,1.61-4.41,1.89-4.41,1.89-1.59,0-5-.18-6.25-1.35-8.33-8-8.67-39-8.67-39H734A28,28,0,0,0,744.38,453.78Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M746.58,492.07a8.48,8.48,0,0,0,4.67-1.63c3.35-2.43,5.41-14.26,6.88-22.61,1.39-7.93,2.74-22,2.74-22l-5.67,23.38c-3,12.8-5.44,18.48-7.62,21-1.42,1.61-4.42,1.89-4.42,1.89Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M743.33,436.43a10,10,0,1,1,10-10A10,10,0,0,1,743.33,436.43Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.1,42.26c9.87,0,19.87,8,19.87,17.87S647,78,637.1,78a17.87,17.87,0,0,1,0-35.74Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M558.17,413.66v-150a2.82,2.82,0,0,1,2.8-2.8H683.28a2.8,2.8,0,0,0,2.8-2.8V230.58a2.8,2.8,0,0,0-2.8-2.8h-11a2.41,2.41,0,0,1-2.41-2.41V92.87h0a2.41,2.41,0,0,1,2.41-2.41h72a2.41,2.41,0,0,0,2.41-2.41V64.91h0a2.41,2.41,0,0,0-2.41-2.41h-.8a2.39,2.39,0,0,0-2.42,2.38v16.8h0a2.39,2.39,0,0,1-2.41,2.37H605.84a2.39,2.39,0,0,1-2.37-2.41h0v-9.5h0a2.39,2.39,0,0,1,2.41-2.37h34.4a2.41,2.41,0,0,0,2.41-2.41V64.85h0a2.41,2.41,0,0,0-2.41-2.41h-5.76A2.41,2.41,0,0,1,632.11,60V58.18h0a2.39,2.39,0,0,1,2.41-2.37h5.69a2.41,2.41,0,0,0,2.41-2.41V50.91h0a2.41,2.41,0,0,0-2.41-2.41H592.52a2.41,2.41,0,0,0-2.38,2.41v4.52h0a2.41,2.41,0,0,1-2.41,2.41H519.62a2.39,2.39,0,0,0-2.37,2.41h0V81.72h0a2.39,2.39,0,0,0,2.41,2.37h31.82a2.41,2.41,0,0,1,2.41,2.41v26h0a2.41,2.41,0,0,0,2.41,2.41h48.47a2.41,2.41,0,0,1,2.41,2.41v46.93h0a2.41,2.41,0,0,1-2.41,2.41H587.11a2.41,2.41,0,0,0-2.41,2.41v7.52h0a2.41,2.41,0,0,0,2.41,2.41H705.62a2.41,2.41,0,0,1,2.41,2.41v9.35h0a2.41,2.41,0,0,1-2.41,2.41h-102a2.41,2.41,0,0,0-2.41,2.41v22.53h0a2.41,2.41,0,0,0,2.41,2.41h87.66a2.8,2.8,0,0,1,2.8,2.8v42.76a2.8,2.8,0,0,1-2.8,2.8H568.69a2.8,2.8,0,0,0-2.8,2.8v142"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M871.62,207.43h8.09a2.41,2.41,0,0,1,2.41,2.41v87.3a3.5,3.5,0,0,1-3.5,3.5H669.08a3.5,3.5,0,0,0-3.5,3.5v28.19"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M763.28,147.32h1.61a5.77,5.77,0,0,1,5.77,5.77h0v47.57a2.83,2.83,0,0,1-2.82,2.82h-7.51a2.82,2.82,0,0,1-2.82-2.82h0V153.08A5.78,5.78,0,0,1,763.28,147.32Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M798.52,150.73h0a7.44,7.44,0,0,1,7.44,7.44h0V172.5a7.44,7.44,0,0,1-7.44,7.44h0a7.44,7.44,0,0,1-7.43-7.44V158.17a7.43,7.43,0,0,1,7.42-7.44Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 794.31,
    y1: 162.6,
    x2: 794.31,
    y2: 174.34
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 797.15,
    y1: 163.28,
    x2: 797.15,
    y2: 175.02
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 799.98,
    y1: 163.28,
    x2: 799.98,
    y2: 175.02
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 802.82,
    y1: 162.6,
    x2: 802.82,
    y2: 174.34
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M818.23,150.73h0a7.44,7.44,0,0,1,7.43,7.44V172.5a7.46,7.46,0,0,1-7.43,7.44h0a7.44,7.44,0,0,1-7.44-7.44h0V158.17a7.44,7.44,0,0,1,7.44-7.44Z"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 813.97,
    y1: 162.6,
    x2: 813.97,
    y2: 174.34
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 816.81,
    y1: 163.28,
    x2: 816.81,
    y2: 175.02
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 819.64,
    y1: 163.28,
    x2: 819.64,
    y2: 175.02
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 822.47,
    y1: 162.6,
    x2: 822.47,
    y2: 174.34
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 771.89,
    y: 174.43,
    width: 105.73,
    height: 31.67
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 771.89,
    y: 131.69,
    width: 13.52,
    height: 22.9
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "771.89 146.26 764.09 198.95 771.89 198.95 771.89 146.26"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M764.09,137.76h0a2.41,2.41,0,0,1,2.4,2.41v4.74a2.43,2.43,0,0,1-2.4,2.41h0a2.41,2.41,0,0,1-2.41-2.41h0v-4.74A2.41,2.41,0,0,1,764.09,137.76Z"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 778.65,
    y1: 179.98,
    x2: 778.65,
    y2: 201.43
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 851,
    y: 164.55,
    width: 1.37,
    height: 9.79
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 851.99,
    cy: 161.13,
    r: 4.23
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 850.71,
    y1: 161.94,
    x2: 851.99,
    y2: 161.13
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M781.74,154.76a3.12,3.12,0,1,1-6.18,0Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M778.65,158.31V165a5.74,5.74,0,0,0,5.73,5.75h0a5.73,5.73,0,0,0,3.61-1.28l3.12-2.53"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 839.49,
    y: 160.23,
    width: 2.82,
    height: 7.41
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 835.8,
    y: 156.9,
    width: 7.37,
    height: 4.59,
    rx: 2.29
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 865.08,
    y: 169.15,
    width: 7.74,
    height: 5.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 868.94,
    cy: 164.52,
    r: 6.42
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 771.89,
    y: 206.21,
    width: 7.18,
    height: 4.52
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 870.44,
    y: 206.21,
    width: 7.18,
    height: 4.52
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 795.42,
    cy: 190.61,
    r: 6.03
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 817.39,
    cy: 190.61,
    r: 6.03
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 839.36,
    cy: 190.61,
    r: 6.03
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 861.32,
    cy: 190.61,
    r: 6.03
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M835,159.19h0a4.83,4.83,0,0,0-4.83,4.83h0v9.76"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 833.99,
    y: 168.82,
    width: 25.4,
    height: 5.53
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 707.27,
    y: 143.46,
    width: 2.82,
    height: 25
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 706.41,
    y: 140.13,
    width: 14.25,
    height: 4.59,
    rx: 2.29
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 618.77,
    y: 166.75,
    width: 103.44,
    height: 39.4,
    rx: 17.45
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "656.91 162.56 639.6 162.56 640.44 158.28 656.07 158.28 656.91 162.56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 638.08,
    y: 163,
    width: 42.84,
    height: 3.74
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M685.57,166.65a3.12,3.12,0,1,1,6.19-.79h0a3.48,3.48,0,0,1,0,.79Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M688.66,160.42h4a2.54,2.54,0,0,0,2.54-2.54h0v-3.2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 635.01,
    y: 206.25,
    width: 7.18,
    height: 4.52
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 698.8,
    y: 206.25,
    width: 7.18,
    height: 4.52
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 697.8,
    y: 156.49,
    width: 1.37,
    height: 9.79
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 698.8,
    cy: 153.05,
    r: 4.23
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 697.52,
    y1: 153.87,
    x2: 698.8,
    y2: 153.05
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M627.34,150.43h0a7.43,7.43,0,0,1,7.43-7.43h24.11a7.44,7.44,0,0,1,7.44,7.43h0a7.44,7.44,0,0,1-7.44,7.44h-24.1a7.44,7.44,0,0,1-7.44-7.44Z"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 638.08,
    y1: 154.68,
    x2: 660.59,
    y2: 154.68
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 638.99,
    y1: 151.84,
    x2: 661.88,
    y2: 151.84
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 638.99,
    y1: 149.01,
    x2: 661.88,
    y2: 149.01
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 638.08,
    y1: 146.18,
    x2: 660.59,
    y2: 146.18
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 625.21,
    y: 140.79,
    width: 10.76,
    height: 19.27,
    rx: 3.81
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M659,121.7h20.13a1.74,1.74,0,0,1,1.74,1.74h0a1.74,1.74,0,0,1-1.74,1.74H659Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "676.95 141.25 662.88 141.25 661.88 128.66 677.95 128.66 676.95 141.25"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "662.88 121.12 676.95 121.12 677.95 128.25 661.88 128.25 662.88 121.12"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 655.11,
    y: 118.89,
    width: 4.59,
    height: 9.76,
    rx: 2.29
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "680.17 163 659.66 163 660.66 140.73 679.17 140.73 680.17 163"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M680.85,123.44h5.28a2.54,2.54,0,0,1,2.53,2.54v40.77"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "756.71 75.71 729.89 75.71 731.2 69.07 755.4 69.07 756.71 75.71"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 710.89,
    y: 45.38,
    width: 60.4,
    height: 23.05,
    rx: 11.52
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 727.54,
    y1: 63.49,
    x2: 762.42,
    y2: 63.49
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 728.94,
    y1: 59.1,
    x2: 764.42,
    y2: 59.1
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 728.94,
    y1: 54.71,
    x2: 764.42,
    y2: 54.71
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 727.54,
    y1: 50.31,
    x2: 762.42,
    y2: 50.31
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 707.59,
    y: 41.97,
    width: 16.68,
    height: 29.86,
    rx: 5.9
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M622.52,49.5h17.69a2.41,2.41,0,0,1,2.41,2.41h0V54.4a2.41,2.41,0,0,1-2.41,2.41h-5.76A2.39,2.39,0,0,0,632,59.14v0h0V61a2.41,2.41,0,0,0,2.41,2.41h5.76a2.41,2.41,0,0,1,2.41,2.41h0v2.51a2.41,2.41,0,0,1-2.41,2.41H623"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M637.1,42.26c9.87,0,19.87,8,19.87,17.87S647,78,637.1,78a17.87,17.87,0,0,1,0-35.74Z"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "767.65 402 802.03 417.64 802.03 435.63 767.65 450.75 758.13 451.49 758.13 400.92 767.65 402"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 410.75,
    y: 399.65,
    width: 25.83,
    height: 53.63
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 415.78,
    y: 456.84,
    width: 20.09,
    height: 7.15
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 415.78,
    y: 388.9,
    width: 20.09,
    height: 7.15
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 508.46,
    y: 456.84,
    width: 20.09,
    height: 7.15
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 508.46,
    y: 388.9,
    width: 20.09,
    height: 7.15
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 404.29,
    y: 407.51,
    width: 6.46,
    height: 37.9
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 436.58,
    y: 409.66,
    width: 8.01,
    height: 33.61
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 502.01,
    y: 409.66,
    width: 6.46,
    height: 33.61
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 508.46,
    y: 399.65,
    width: 20.09,
    height: 53.63
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 389.77,
    y: 414.58,
    width: 14.53,
    height: 23.6
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "377.2 429.23 377.2 423.52 389.01 423.54 389.01 429.25 377.2 429.23"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 444.45,
    y: 318.87,
    width: 57.15,
    height: 215.19
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 525.86,
    width: 45.12,
    height: 3.81
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 516.58,
    width: 45.12,
    height: 5.88
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 505.27,
    width: 45.12,
    height: 7.93
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 491.89,
    width: 45.12,
    height: 9.98
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 476.45,
    width: 45.12,
    height: 12.04
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 458.96,
    width: 45.12,
    height: 14.1
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 439.41,
    width: 45.12,
    height: 16.15
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 417.8,
    width: 45.12,
    height: 18.21
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 365.07,
    width: 45.12,
    height: 12.04
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 380.51,
    width: 45.12,
    height: 14.1
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 398.01,
    width: 45.12,
    height: 16.15
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 323.89,
    width: 45.12,
    height: 3.81
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 331.1,
    width: 45.12,
    height: 5.88
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 340.37,
    width: 45.12,
    height: 7.93
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 450.41,
    y: 351.7,
    width: 45.12,
    height: 9.98
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 767.65,
    y1: 402,
    x2: 767.65,
    y2: 450.75
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 641.26,
    y: 353.51,
    width: 2.19,
    height: 24.2,
    transform: "translate(9.22 746.98) rotate(-60.71)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 643.1,
    y: 329.17,
    width: 2.19,
    height: 3.92,
    transform: "translate(74.17 778.02) rotate(-65.3)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 671.38,
    y: 344.14,
    width: 2.19,
    height: 3.92,
    transform: "translate(77.03 812.43) rotate(-65.3)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M649.93,371.34s-4.32-2.74-8-4.88-8.21-4.61-8.21-4.61l14.08-39.22s6.19,1.05,15.84,6.7,13.59,10.53,13.59,10.53Z"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 630.47,
    y: 486.64,
    width: 24.2,
    height: 2.19,
    transform: "translate(-155.17 367.8) rotate(-28.65)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 641.19,
    y: 520.97,
    width: 3.92,
    height: 2.19,
    transform: "translate(-156.96 307.57) rotate(-24.06)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 672.08,
    y: 507.46,
    width: 3.92,
    height: 2.19,
    transform: "translate(-148.77 318.98) rotate(-24.06)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M650.2,482.15s-4.35,2.69-8,4.79-8.27,4.52-8.27,4.52l13.64,39.37s6.21-1,15.92-6.51,13.71-10.39,13.71-10.39Z"
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 848.25,
    y1: 345.11,
    x2: 882.68,
    y2: 341.27
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 848.25,
    y1: 507.53,
    x2: 882.68,
    y2: 511.38
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "54.6 293.44 54.6 447.37 43.47 447.37 43.47 80.59 54.6 80.59 54.6 293.44"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "79.34 293.44 79.34 447.37 68.2 447.37 68.2 80.59 79.34 80.59 79.34 293.44"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 430.4,
    y: 131.74,
    width: 22.35,
    height: 79.04
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 452.75,
    y: 131.74,
    width: 22.35,
    height: 79.04
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 145.19,
    x2: 470.37,
    y2: 145.19
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 149.53,
    x2: 470.37,
    y2: 149.53
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 153.88,
    x2: 470.37,
    y2: 153.88
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 158.22,
    x2: 470.37,
    y2: 158.22
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 452.75,
    y1: 171.26,
    x2: 475.11,
    y2: 171.26
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 475.11,
    y: 131.74,
    width: 22.35,
    height: 79.04
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 145.19,
    x2: 492.72,
    y2: 145.19
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 149.53,
    x2: 492.72,
    y2: 149.53
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 153.88,
    x2: 492.72,
    y2: 153.88
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 158.22,
    x2: 492.72,
    y2: 158.22
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 475.11,
    y1: 171.26,
    x2: 497.46,
    y2: 171.26
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 497.46,
    y: 131.74,
    width: 22.35,
    height: 79.04
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 145.19,
    x2: 515.07,
    y2: 145.19
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 149.53,
    x2: 515.07,
    y2: 149.53
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 153.88,
    x2: 515.07,
    y2: 153.88
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 158.22,
    x2: 515.07,
    y2: 158.22
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 497.46,
    y1: 171.26,
    x2: 519.81,
    y2: 171.26
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 519.81,
    y: 131.74,
    width: 22.35,
    height: 79.04
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 145.19,
    x2: 537.42,
    y2: 145.19
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 149.53,
    x2: 537.42,
    y2: 149.53
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 153.88,
    x2: 537.42,
    y2: 153.88
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 158.22,
    x2: 537.42,
    y2: 158.22
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 184.21,
    x2: 470.37,
    y2: 184.21
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 188.56,
    x2: 470.37,
    y2: 188.56
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 192.91,
    x2: 470.37,
    y2: 192.91
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 457.49,
    y1: 197.25,
    x2: 470.37,
    y2: 197.25
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 145.19,
    x2: 448.02,
    y2: 145.19
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 149.53,
    x2: 448.02,
    y2: 149.53
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 153.88,
    x2: 448.02,
    y2: 153.88
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 158.22,
    x2: 448.02,
    y2: 158.22
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 430.4,
    y1: 171.26,
    x2: 452.75,
    y2: 171.26
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 184.21,
    x2: 448.02,
    y2: 184.21
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 188.56,
    x2: 448.02,
    y2: 188.56
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 192.91,
    x2: 448.02,
    y2: 192.91
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 435.14,
    y1: 197.25,
    x2: 448.02,
    y2: 197.25
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 184.21,
    x2: 492.72,
    y2: 184.21
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 188.56,
    x2: 492.72,
    y2: 188.56
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 192.91,
    x2: 492.72,
    y2: 192.91
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 479.84,
    y1: 197.25,
    x2: 492.72,
    y2: 197.25
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 184.21,
    x2: 515.07,
    y2: 184.21
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 188.56,
    x2: 515.07,
    y2: 188.56
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 192.91,
    x2: 515.07,
    y2: 192.91
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 502.19,
    y1: 197.25,
    x2: 515.07,
    y2: 197.25
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 184.21,
    x2: 537.42,
    y2: 184.21
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 188.56,
    x2: 537.42,
    y2: 188.56
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 192.91,
    x2: 537.42,
    y2: 192.91
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 524.54,
    y1: 197.25,
    x2: 537.42,
    y2: 197.25
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 519.81,
    y1: 171.26,
    x2: 542.16,
    y2: 171.26
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 542.16,
    y: 131.74,
    width: 22.35,
    height: 79.04
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 145.19,
    x2: 559.77,
    y2: 145.19
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 149.53,
    x2: 559.77,
    y2: 149.53
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 153.88,
    x2: 559.77,
    y2: 153.88
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 158.22,
    x2: 559.77,
    y2: 158.22
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 184.21,
    x2: 559.77,
    y2: 184.21
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 188.56,
    x2: 559.77,
    y2: 188.56
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 192.91,
    x2: 559.77,
    y2: 192.91
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 546.89,
    y1: 197.25,
    x2: 559.77,
    y2: 197.25
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 542.16,
    y1: 171.26,
    x2: 564.51,
    y2: 171.26
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M727.7,435.61s1.12,14.52,6.88,20.71c0,0,1.2,1.46,2.14-1.29s7.14-31.63,7.65-36.53C744.37,418.5,740.51,426.84,727.7,435.61Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M742.83,433.63s11.25-8.85,16.24-26a26.49,26.49,0,0,0-3.61-22.94s-1.72-2-2.58.25l-2.23,9.11-5.42,27.16Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M744.81,436.53a5.2,5.2,0,0,1-1.11,2.36,9.16,9.16,0,0,0-1.89,2.8c-1.07,4.55-2.62,10.81-3.2,12,0,0-1.37,3.53-3.18,3.05.63.05,1.32-1.7,1.32-1.7.88-2.6,7.15-31.6,7.67-36.5,0,0,6.23-29.65,8.72-34,0,0-1.17,7.95-1.94,11.47-.1.47-.35,1.7-.7,3.49a10,10,0,0,0,.29,3.73,4.63,4.63,0,0,1,.14,2.92Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M542.21,282.45v42.31l-7.69-3A112.87,112.87,0,0,0,493,313.81H430.17v-38.6h59.24a199.94,199.94,0,0,1,52.8,7Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M390.53,577.45H477.2c11.57,0,24.41-1.5,24.41-1.5V538.78c-3.72.35-8.62.33-8.62.33H423.77a119.37,119.37,0,0,1-33.24-4.68v43Z"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 649.5,
    y: 446.83,
    width: 20,
    height: 7.15
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 649.5,
    y: 409.66,
    width: 20,
    height: 33.61
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 649.5,
    y: 398.92,
    width: 20,
    height: 7.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "malfunctions"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfunctionsKaplanHorizontal);
export default __webpack_public_path__ + "static/media/malfunctions_kaplan-horizontal.b8d26cd6fff7e01afca8135abc32d7a8.svg";
export { ForwardRef as ReactComponent };